(() => {
 if(window.casaGiftDraftReady)return;window.casaGiftDraftReady=true;
 document.addEventListener('click',event=>{
  const open=event.target.closest('[data-cmg-open]');
  if(open){const dialog=document.getElementById(open.dataset.cmgOpen);if(dialog){dialog.dataset.returnFocus='';dialog._opener=open;dialog.showModal();}}
  const close=event.target.closest('[data-cmg-close]');if(close)close.closest('dialog').close();
 });
 document.querySelectorAll('.cmg-dialog').forEach(dialog=>{
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
  dialog.addEventListener('close',()=>dialog._opener?.focus());
 });
 let timer;
 async function updateDelivery(){
  try{
   const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'}});if(!response.ok)return;
   const cart=await response.json();document.querySelectorAll('[data-cmg-delivery]').forEach(el=>{
    const target=Number(el.dataset.threshold);const total=Number(cart.total_price);const left=Math.max(0,target-total);
    el.querySelector('[data-cmg-progress]').value=Math.min(target,total);
    el.querySelector('[data-cmg-delivery-text]').textContent=left===0?'Your basket qualifies for free UK mainland delivery':total>0?`Add £${(left/100).toFixed(2)} for free UK mainland delivery`:'Free UK mainland delivery on orders £55+';
   });
  }catch(e){}
 }
 const schedule=()=>{clearTimeout(timer);timer=setTimeout(updateDelivery,350);};
 ['cart:updated','cart:refresh','cart:change','CART_UPDATED','cart-update','cart:added','cart-updated','krown:cart:add','krown:cart:update'].forEach(name=>document.addEventListener(name,schedule,true));
 const cartCount=document.querySelector('[data-header-cart-count]');
 if(cartCount)new MutationObserver(schedule).observe(cartCount,{childList:true,subtree:true,characterData:true});
 document.addEventListener('submit',e=>{if(e.target.matches('form[data-type="add-to-cart-form"]')){setTimeout(updateDelivery,1000);setTimeout(updateDelivery,2500);}},true);
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
 updateDelivery();
})();
